<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-8 order-md-1">

                <loading v-if="loading"/>
                <div v-else>
                    <!-- Home page partner message -->
                    <home-message/>

                    <views-home-type-products v-if="type === types.products"
                                              :grouping="groupingType"
                                              :groupings="groupings"
                                              :config="config"
                                              :catalog-message="catalogMessage"/>

                    <views-home-type-categories v-if="type === types.categories"
                                                :grouping="groupingType"
                                                :groupings="groupings"
                                                :catalog-message="catalogMessage"/>

                    <products-list v-if="products"
                                   class="mt-3"
                                   :value="products.items"
                                   :grouping="groupingType"
                                   :grouping-id="products.groupingId"/>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 order-md-0">
                <panel>
                    <orders-history/>
                </panel>
                <panel class="mt-4">
                    <orders-question/>
                </panel>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapGetters} from "vuex";

    import mixinView from "@/mixins/view";
    import mixinConstraints from "@/mixins/constraints";
    import mixinWidget from "@mixins_widget";

    import emitter, {EVENTS} from "@/api/events";
    import {retryRequest} from "@/helpers/request";

    import HomeMessage from "@components_home_HomeMessage";
    import Loading from "@/components/Loading";
    import ProductsList from "@/components/products/ProductsList";
    import AdvisorRecommendations from "@/components/advisor/AdvisorRecommendations";
    import Panel from "@/components/Panel";
    import OrdersHistory from "@/components/orders/OrdersHistory";
    import ViewsHomeTypeProducts from "@/views/home/ViewsHomeTypeProducts";
    import ViewsHomeTypeCategories from "@/views/home/ViewsHomeTypeCategories";
    import {CATALOG_STATUS_MESSAGE, CATALOG_ROOT_CATEGORY, HOME_PAGE_GROUPING_TYPE} from "@/constants";
    import OrdersQuestion from "@/components/orders/OrdersQuestion";

    const TYPE = process.env.VUE_APP_HOME_PAGE_TYPE;

    export default {
        name: "ViewsHome",
        mixins: [mixinView, mixinConstraints, mixinWidget],
        components: {
            HomeMessage,
            OrdersQuestion,
            ViewsHomeTypeCategories,
            ViewsHomeTypeProducts,
            AdvisorRecommendations,
            ProductsList,
            Loading,
            Panel,
            OrdersHistory
        },
        data() {

            return {
                t_path: "views.home",

                loading: false,
                types: {
                    products: "products",
                    categories: "categories"
                },
                type: TYPE,
                config: {
                    default: {
                        max_items: null,
                        item_wrap: true
                    }
                },
                products: null,
                catalogMessageSource: null
            }
        },
        computed: {
            ...mapGetters({
                groupings: "grouping/items",
                groupingType: "grouping/type"
            }),
            catalogMessage() {

                if (CATALOG_STATUS_MESSAGE) {

                    return this.catalogMessageSource
                        ? this.$t(`catalog.message.${this.catalogMessageSource.message}`, {
                            equipmentQuizLink: this.$router.resolve({name: "quiz", query: {reset: true}}).fullPath,
                            widgetOptions: this.widget_optionsJson,
                            supportEmail: this.catalogMessageSource.email
                        })
                        : null;
                }

                return 0 === this.groupings.length && (!this.products || 0 === this.products.items.length)
                    ? this.t("noAvailableItems", {
                        widgetOptions: this.widget_optionsJson
                    })
                    : null
            }
        },
        methods: {
            handleConfig(data) {

                this.config.default.max_items = data.config.max_items;
                this.config.default.item_wrap = data.config.item_wrap;
            },
            handleActivity() {

                if (0 === this.groupings.length) {

                    this.$activity.log("catalog_no_groupings", {constraints: this.$store.getters["user/constraints/type"]});
                    this.$activity.log("catalog_no_products", {constraints: this.$store.getters["user/constraints/type"]});

                    return false;
                }

                this.$activity.log("catalog_groupings", {
                    groupings: this.groupings.map(grouping => ({name: grouping.name, id: grouping.id})),
                    constraints: this.$store.getters["user/constraints/type"]
                });
            },
            fetch() {

                if (!this.constraints_hasUserAvailableProducts()) {

                    this.$activity.log("catalog_no_products", {constraints: this.$store.getters["user/constraints/type"]});

                    return false;
                }

                this.loading = true;

                const promises = [
                    this.$store.dispatch("grouping/fetch", {type: HOME_PAGE_GROUPING_TYPE}),
                    retryRequest(() => this.$platform.get(`/api/v2/hp_config`)),
                ];

                if (CATALOG_STATUS_MESSAGE) {

                    promises.push(this.$store.dispatch("user/catalog/getCatalogMessage"))
                }

                return Promise
                    .all(promises)
                    .then(responses => {

                        const [catalog, config, catalogMessage] = responses;

                        this.catalogMessageSource = catalogMessage && catalogMessage.message
                            ? catalogMessage
                            : null;

                        this.handleConfig(config.data.results);
                        this.handleActivity();

                        if (true === CATALOG_ROOT_CATEGORY) {

                            return this.$platform
                                .get(`/api/v2/grouping/${this.groupingType}/${this.$store.getters["grouping/rootItem"].id}?hiearchy_search=false`)
                                .then(response => {

                                    this.products = {
                                        groupingId: response.data.results._id,
                                        items: response.data.results.products
                                    };
                                });
                        }
                    })
                    .finally(() => this.loading = false);
            },
            refreshProducts() {

                if (this.products) {

                    this.$platform
                        .get(`/api/v2/grouping/${this.groupingType}/${this.products.groupingId}?hiearchy_search=false`)
                        .then(response => this.products.items = response.data.results.products);
                }
            }
        },
        mounted() {

            this.fetch();

            emitter.on(EVENTS.USER_CONSTRAINTS_FETCH, this.refreshProducts);
        },
        beforeUnmount() {

            emitter.off(EVENTS.USER_CONSTRAINTS_FETCH, this.refreshProducts);
        }
    }
</script>